import {Component, EventEmitter, Injectable, Input, OnInit, Output} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {Router} from '@angular/router';
import {UserService} from 'src/shared/services/user/user.service';

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.scss']
})
@Injectable()
export class ForgotPasswordComponent implements OnInit {
  public users: any[] = [];
  public form: FormGroup;
  public userName: any;

  @Input() error: string;
  loading: boolean;

  @Output()
  connect = new EventEmitter();
  loadingRequestCharges: boolean;

  constructor(
    private fb: FormBuilder,
    public user: UserService,
    private router: Router
  ) {}

  ngOnInit() {
    this.loading = false;
    this.form = this.fb.group({
      email: ['', Validators.required]
    });
  }

  onChangePassword() {
    this.loading = true;
    let found = false;
    if (this.form.value.email.includes('@')) {
      this.user
        .transformEmailUsername(this.form.value.email)
        .then(res => {
          let i = 0;

          for (i; i < res.people.length; i++) {
            if (res.people[i].email === this.form.value.email) {
              this.userName = res.people[i].userName;
              this.onResetPass(this.userName);
              this.loading = true;
              found = true;
            }
          }
          if (!found) {
            this.error =
              'Désolé, le compte que vous avez saisi n\'existe pas dans notre annuaire. Veuillez recommencer ou contacter votre administrateur.';
          }
        })
        .finally(() => (this.loading = false));
    } else {
      this.onResetPass(this.form.value.email);
      this.loading = true;
    }
  }

  onResetPass(t) {
    const x = this.connect.emit(t);
    this.loading = true;
    this.router.navigate(['/', 'go-to-login']);
    this.user
      .updatePassword(t)
      .then(res => {
     
      })
      .catch(error => {
        this.error = error.error.message;
        this.loading = false;
      });
  }

  onReturn() {
    this.router.navigate(['/', 'connexion']);
  }
}
